<ps-dropdown [dataCy]="dataCy()">
  <ps-button
    class="ps-dropdown-button-trigger"
    [variant]="variant()"
    [color]="color()"
    [size]="size()"
    [disabled]="disabled()"
    [ariaLabel]="triggerAriaLabel()"
    [ariaExpanded]="menuOpen()"
    [psDropdownTriggerFor]="menu"
    [psDropdownMenuPosition]="resolvedMenuPosition()"
    (psDropdownOpened)="onTriggerOpened()"
    (psDropdownClosed)="onTriggerClosed()"
  >
    <span class="ps-dropdown-button-label">
      <ng-content select="[psDropdownButtonLabel]"></ng-content>
    </span>

    <span
      class="ps-dropdown-button-caret"
      [class.ps-dropdown-button-caret-open]="menuEffect()"
    >
      <ps-icon [name]="iconName()" [size]="iconSize()" />
    </span>
  </ps-button>
  <ng-template #menu>
    <div
      psDropdownMenu
      class="ps-dropdown-button-menu"
      [attr.aria-label]="menuAriaLabel()"
      [attr.data-cy]="menuDataCy()"
    >
      @for (entry of resolvedMenuRows(); track entry.trackId) {
        @if (entry.kind === 'divider') {
          <ps-divider />
        } @else {
          <button
            type="button"
            class="dropdown-item"
            cdkMenuItem
            [disabled]="entry.item.disabled === true"
            (cdkMenuItemTriggered)="onRowTriggered(entry.item)"
          >
            {{ entry.item.label }}
          </button>
        }
      }
    </div>
  </ng-template>
</ps-dropdown>
